import './Text.css';



export function HDYLSWWYD() {
  return (
    <div class="body">



<div class="row">
  <div class="column">
        <h2>TOO COMFORTABLY</h2>
        <h4>White supremacy 
is running from its own fart. Technological advancement and increasingly accessible information is blowing the industrial gasses, corpse methane, and destabilized descendants of the global south above the equator. 
<br/><br/>As American grocery items solidify, rather than rot; as cities diversify with Israeli-Owned dispensaries, faster than bus-lanes and new trees; and political bumper stickers clothe the nukes that hit the ones who made them; Americans scramble to find the prettiest pair of noise-canceling headphones, to drown out their demise and destruction.
</h4>
      </div>
      <div class="column">
        <img src="TooComfrotablyAlbumCover2.jpg"></img>
      </div>
      <div class="column">
        <img src="TooComfrotablyAlbumCover.jpg"></img>
      </div>
            
      <div class="column">
        <h2>During the 2026 Minneapolis ICE Surge,</h2>
<h4> Amar watched their White, private art school struggle to understand how to protect and care about the marginalized students, it predatorily seeks out. 

<br/><br/>I realised that many of Them aren’t intentionally malicious. They just, truly don’t know how to nurture community. Because of the comfortable lives they’ve lived within the hegemony, they only know how to steal, build borders, and consume others.
If we let them remain evasive or responsibilty, we continue to pay for their weaponized incompetence.
</h4>
      </div>
      <div class="column">
        <video autoplay controls loop >
            <source src="InformalComplaint.mp4" type="video/mp4"/>
          </video>  
      <br/><h4>Informal Complaint<br/>13m 8s</h4>
      </div>
      
      <div class="column">
        <video autoplay controls loop >
            <source  src="TheFriend.mp4" type="video/mp4"/>
          </video>
           <br/><h4><a href="" target="0">The Friend of a White Man is an Enemy To Me</a>
<br/> Poem accompanied by <a href="https://hypnoticbrass.bandcamp.com/album/hypnotic-joints" target="0">One Hunnit (2017) Hypnotic Brass Ensemble</a>
<br/>13m 8s</h4>
      </div>
            <div class="column">
        <h2>They living too... </h2>

<h4>
Too Comfortably is compilation of Amar’s research on systematic racism in academia, and predominantly white institutions. 

<br/><br/>
Pulling from Dr. Beverly Tatum’s Why Are All the Black Kids Sitting Together in the Cafeteria? (2003), and other gradute-level research, Amar acknowledged that when music, food, clothes, education, and attitudes got less White, they became more soulful, and more borders were built around it. The more Whiteness hated it, yet were hungry for it at the same time.
<br/><br/>
Amar acknowledged that when it came to taking care of others, the closer to White you are, the worse you are at it. And that disease is contagious. Fatal.
</h4>
      </div>
            <div class="column">
        <video autoplay controls loop >
            <source  src="TooComfortably.mp4" type="video/mp4"/>
          </video>
           <br/><h4>Too Comfortably
<br/>2m 52s</h4>  
      </div>
      <div class="column">
        <a href="https://youtu.be/Lg5l_1phW4A?t=4391" target="_blank">
        <img src="YamaneikaSaunders.jpeg"></img></a>
         <br/><h4>Yamaneika Saunders
(on The Downside with Gianmarco Soresi)
<br/>4m 35s</h4>
      </div>
            <div class="column">

<h2>The only remedy...</h2><h4>
 for all of us is to Get loud before they take away your voice.
 <br/><br/> Turn the hands of a clock back manually.
</h4></div>

            <div class="column">
        <video autoplay controls loop>
            <source  src="OpenMic.mp4" type="video/mp4"/>
          </video>
           <br/><h4>Too Comfortably Slam, filmed by Ria Haji
<br/>2m 52s</h4>  
      </div>

      <div class="column">
        <img src="TooComfrotablyAlbumCover33.jpg"></img>
       <br/><h4>Ria Haji 2026<br/>7 digital photos</h4>
      </div>

      <div class="column">
        <img width="630px" src="RiaBio.png"></img>
      </div>

      <div class="column"><img src="RiaBio_Page.jpg"></img>
       </div>

      <div class="column"><img src="RiaBio_Page2.jpg"></img>
      </div>
      
</div>
<br/><br/><br/><br/><br/><br/><br/>


    </div>

  );
}
